import getAcceptProfessionalAffirmationData from "components/utility/api/GetAcceptProfessionalAffirmation";
import getAudienceTypeLocationData from "components/utility/api/GetAudienceTypeLocationData";
import getAudienceTypesForCountryData from "components/utility/api/GetAudienceTypesForCountryData";
import getSelectAudienceTypeData from "components/utility/api/GetSelectAudienceType";
export const individualGUID = "72F4ED1678744217ADBB47C57F3F0638";
export const financialProfessionalGUID = "E5058E607C494673AD1EA98EEA717C17";
export const changeCountry = async (
	event,
	audienceTypesData,
	setCountryListData,
	isSplashModal = false
) => {
	if (event.type === "keydown" && ["Tab", "Shift"].includes(event.key)) return;
	let baseUrl = window.location.origin;
	const countryApiUrl = {
		apiUrl: audienceTypesData.countrySelection.apiUrl
	};

	const countryListData = await getAudienceTypeLocationData(
		baseUrl,
		countryApiUrl,
		audienceTypesData.countryKey,
		isSplashModal
	);

	if (countryListData.status === "success") {
		const countryKey = audienceTypesData.countryKey;
		let newCountryData = { ...countryListData.data, countryKey };
		setCountryListData(newCountryData);
	}
};

export const getLocationData = async (apiParams, countryListData, setAudienceTypesData) => {
	const audienceType = { apiUrl: countryListData.apiUrl, ...apiParams };
	const locationApiData = await getAudienceTypesForCountryData(audienceType);
	if (locationApiData.status === "success") {
		setAudienceTypesData(locationApiData.data);
	}
};

export const getAudienceSelection = async (
	e,
	val,
	redirect,
	audienceTypesData,
	setAudienceSelectionData,
	currentPage
) => {
	if (e.type === "click" || e.key === "Enter") e.preventDefault();
	const audienceUrl = window.location.origin + audienceTypesData.apiUrl;
	const audienceSelectionData = await getSelectAudienceTypeData(
		audienceUrl,
		val.audienceTypeId,
		audienceTypesData.countryKey
	);

	if (audienceSelectionData.status === "success") {
		setAudienceSelectionData(audienceSelectionData.data);
		if (audienceSelectionData.data === "reload") {
			switch (currentPage) {
				case "nav": {
					if (redirect) {
						window.location.replace(window.location.origin + "/");
					} else {
						window.location.replace(
							window.location.origin + window.audienceSwitcherModal.redirectUrl
						);
					}
					break;
				}
				case "global-splash": {
					window.location.replace(window.location.origin + window.splashPageModal.redirectUrl);
					break;
				}
				case "unknown-splash": {
					window.location.replace(
						window.location.origin + window.unknownAudienceSplashPage.redirectUrl
					);
					break;
				}
				case "professional-affirmation": {
					window.location.replace(
						window.location.origin + window.professionalAffirmationSplashPage.redirectUrl
					);
					break;
				}
				case "from-link": {
					const modalInitData = window["audienceSelectorModalFromLink"];
					if (modalInitData.reload) window.location.reload();
					if (
						modalInitData.countryKey === audienceTypesData.countryKey &&
						val.audienceTypeId === individualGUID
					) {
						// notify analytics about the change in content
						window.dataLayer.push({
							event: "page_view",
							audience: "individual investor",
							splash: 0
						});
						break;
					} else {
						// remove /us-en/, /de-de/, /gb-en/, etc
						const redirectURL = modalInitData.redirectUrl;
						window.location.replace(redirectURL.replace(/\/\w{2}-\w{2}(\/)/, "$1"));
						break;
					}
				}
				default: {
					window.location.replace(window.location.origin);
				}
			}
		}
	}
};

export const sendAcceptContinue = async (
	audienceSelectionData,
	currentPage,
	cameFromInitialStep = true
) => {
	const affirmationCheck = true;
	if (affirmationCheck) {
		let baseUrl = window.location.origin;
		baseUrl = baseUrl + audienceSelectionData.apiUrl;
		const proAffData = await getAcceptProfessionalAffirmationData(
			baseUrl,
			audienceSelectionData.countryKey
		);

		if (proAffData.status === "success") {
			if (proAffData.data === "reload") {
				switch (currentPage) {
					case "nav": {
						if (cameFromInitialStep) {
							window.location.href =
								window.location.origin + window.audienceSwitcherModal.redirectUrl;
						} else {
							window.location.href = window.location.origin + "/";
						}
						break;
					}
					case "global-splash": {
						window.location.href = window.location.origin + window.splashPageModal.redirectUrl;
						break;
					}
					case "unknown-splash": {
						window.location.href =
							window.location.origin + window.unknownAudienceSplashPage.redirectUrl;
						break;
					}
					case "professional-affirmation": {
						window.location.href =
							window.location.origin + window.professionalAffirmationSplashPage.redirectUrl;
						break;
					}
					case "from-link": {
						// remove /us-en/, /de-de/, /gb-en/, etc
						const modalInitData = window["audienceSelectorModalFromLink"];
						const redirectURL = modalInitData.redirectUrl;
						window.location.replace(redirectURL.replace(/\/\w{2}-\w{2}(\/)/, "$1"));

						if (window["professionalAffirmationSplashModal"].reload) window.location.reload();
						break;
					}
					case "pro-only-entry":
						// notify analytics about the change in content
						if (window["professionalAffirmationSplashModal"].reload) window.location.reload();
						window.dataLayer.push({
							event: "page_view",
							audience: "financial professional",
							splash: 0
						});
						break;
					default: {
						window.location.replace(window.location.origin);
					}
				}
			}
		}
	}
};

export const eventMisfired = (event) => {
	event.stopPropagation();
	const allowedKeys = new Set(["Enter", "Space"]);
	if ("code" in event && !allowedKeys.has(event.code)) return true;
	event.preventDefault();
};
